function init(){

}

function log(error){
    console.error(error);
}

export default{
    init,
    log
};


// WEBPACK FOOTER //
// ./src/services/logService.js